// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"08574fff","566":"08574fff","919":"c9616eab"}[chunkId] + ".chunk.css";
};